import { UpperCasePipe } from '@angular/common';
import { Component, Input } from '@angular/core';

import { OrderIntegration } from '@cure-common/enum';

@Component({
  selector: 'app-integration-badge',
  standalone: true,
  imports: [UpperCasePipe],
  templateUrl: './integration-badge.component.html',
  styleUrl: './integration-badge.component.scss',
})
export class IntegrationBadgeComponent {
  @Input() integration!: OrderIntegration;
}
